namespace Matrix.Rebalancer {
    export interface SecurityOverrideRow {
        SecurityId?: number;
        SecurityCode?: string;
        SecurityTypeCode?: string;
        Name?: string;
        LocalCurrency?: string;
        ExposureMultiplier?: number;
        AccountCode?: string;
        IsCash?: boolean;
        IsFund?: boolean;
        IsTradeable?: boolean;
        IsSynthetic?: boolean;
        Deleted?: boolean;
        ExposureCurrency?: string;
        Class1?: string;
        Class2?: string;
        Class3?: string;
        Class4?: string;
        Class5?: string;
        Class6?: string;
        Class7?: string;
        Class8?: string;
        Class9?: string;
        Class10?: string;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
        SecuritySecurityCode?: string;
        SecuritySecurityName?: string;
        SecurityTypeName?: string;
        SecurityTypeCodeRowId?: number;
        SecurityTypeCodeDefaultSortOrder?: number;
        LocalCurrencyName?: string;
        LocalCurrencyRowId?: number;
        LocalCurrencyDefaultSortOrder?: number;
        AccountCodeName?: string;
        AccountCodeAccountTypeCode?: string;
        AccountCodeAccountRoleCode?: string;
        AccountCodeManagerCode?: string;
        AccountCodeBaseCurrency?: string;
        AccountCodeTradeable?: boolean;
        AccountCodeExternallyManaged?: boolean;
        AccountCodeCashOffsetSecurityId?: number;
        AccountCodeMaxCash?: number;
        AccountCodeMinCash?: number;
        AccountCodeDeleted?: boolean;
        AccountCodeClass1?: string;
        AccountCodeClass2?: string;
        AccountCodeClass3?: string;
        AccountCodeClass4?: string;
        AccountCodeClass5?: string;
        AccountCodeClass6?: string;
        AccountCodeClass7?: string;
        AccountCodeClass8?: string;
        AccountCodeClass9?: string;
        AccountCodeClass10?: string;
        AccountCodeRowId?: number;
        ExposureCurrencyName?: string;
        ExposureCurrencyRowId?: number;
        ExposureCurrencyDefaultSortOrder?: number;
    }

    export namespace SecurityOverrideRow {
        export const idProperty = 'SecurityId';
        export const nameProperty = 'SecurityCode';
        export const localTextPrefix = 'Rebalancer.SecurityOverride';
        export const deletePermission = 'DataAdmin:Rebalancer';
        export const insertPermission = 'DataAdmin:Rebalancer';
        export const readPermission = 'Read:Rebalancer';
        export const updatePermission = 'DataAdmin:Rebalancer';

        export declare const enum Fields {
            SecurityId = "SecurityId",
            SecurityCode = "SecurityCode",
            SecurityTypeCode = "SecurityTypeCode",
            Name = "Name",
            LocalCurrency = "LocalCurrency",
            ExposureMultiplier = "ExposureMultiplier",
            AccountCode = "AccountCode",
            IsCash = "IsCash",
            IsFund = "IsFund",
            IsTradeable = "IsTradeable",
            IsSynthetic = "IsSynthetic",
            Deleted = "Deleted",
            ExposureCurrency = "ExposureCurrency",
            Class1 = "Class1",
            Class2 = "Class2",
            Class3 = "Class3",
            Class4 = "Class4",
            Class5 = "Class5",
            Class6 = "Class6",
            Class7 = "Class7",
            Class8 = "Class8",
            Class9 = "Class9",
            Class10 = "Class10",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen",
            SecuritySecurityCode = "SecuritySecurityCode",
            SecuritySecurityName = "SecuritySecurityName",
            SecurityTypeName = "SecurityTypeName",
            SecurityTypeCodeRowId = "SecurityTypeCodeRowId",
            SecurityTypeCodeDefaultSortOrder = "SecurityTypeCodeDefaultSortOrder",
            LocalCurrencyName = "LocalCurrencyName",
            LocalCurrencyRowId = "LocalCurrencyRowId",
            LocalCurrencyDefaultSortOrder = "LocalCurrencyDefaultSortOrder",
            AccountCodeName = "AccountCodeName",
            AccountCodeAccountTypeCode = "AccountCodeAccountTypeCode",
            AccountCodeAccountRoleCode = "AccountCodeAccountRoleCode",
            AccountCodeManagerCode = "AccountCodeManagerCode",
            AccountCodeBaseCurrency = "AccountCodeBaseCurrency",
            AccountCodeTradeable = "AccountCodeTradeable",
            AccountCodeExternallyManaged = "AccountCodeExternallyManaged",
            AccountCodeCashOffsetSecurityId = "AccountCodeCashOffsetSecurityId",
            AccountCodeMaxCash = "AccountCodeMaxCash",
            AccountCodeMinCash = "AccountCodeMinCash",
            AccountCodeDeleted = "AccountCodeDeleted",
            AccountCodeClass1 = "AccountCodeClass1",
            AccountCodeClass2 = "AccountCodeClass2",
            AccountCodeClass3 = "AccountCodeClass3",
            AccountCodeClass4 = "AccountCodeClass4",
            AccountCodeClass5 = "AccountCodeClass5",
            AccountCodeClass6 = "AccountCodeClass6",
            AccountCodeClass7 = "AccountCodeClass7",
            AccountCodeClass8 = "AccountCodeClass8",
            AccountCodeClass9 = "AccountCodeClass9",
            AccountCodeClass10 = "AccountCodeClass10",
            AccountCodeRowId = "AccountCodeRowId",
            ExposureCurrencyName = "ExposureCurrencyName",
            ExposureCurrencyRowId = "ExposureCurrencyRowId",
            ExposureCurrencyDefaultSortOrder = "ExposureCurrencyDefaultSortOrder"
        }
    }
}
